import RelationshipMetadata from "../../RelationshipMetadata";

class DocumentTypeDocumentTypeForm2RelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "DocumentTypeDocumentTypeForm";
        this.parentEnterpriseComponent = "DocumentType";
        this.childEnterpriseComponent = "DocumentTypeForm2";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "DocumentTypeUSID";
    }
}

export default DocumentTypeDocumentTypeForm2RelationshipMetadata;